export enum AnnouncementsNav {
  ANNOUNCEMENTS = 'announcements'
}
